import { render, staticRenderFns } from "./TaskResultsDetails.vue?vue&type=template&id=42809764&"
import script from "./TaskResultsDetails.vue?vue&type=script&lang=js&"
export * from "./TaskResultsDetails.vue?vue&type=script&lang=js&"
import style0 from "./TaskResultsDetails.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports